import React from 'react';

export interface LuminousBreakLogoProps {
  size?: number;
  showText?: boolean;
  subtitle?: string;
  theme?: 'light' | 'dark';
  variant?: 'mark' | 'full';
}

export const LuminousBreakLogo: React.FC<LuminousBreakLogoProps> = ({
  size = 40,
  showText = false,
  subtitle,
  theme = 'light',
  variant = 'mark',
}) => {
  if (variant === 'full') {
    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
        <img
          src="/brand-logo.png"
          alt="Luminous Break"
          style={{
            width: `${size * 2.5}px`,
            maxWidth: '100%',
            height: 'auto',
            display: 'block',
            borderRadius: '12px',
          }}
        />
        {subtitle && (
          <span style={{
            fontSize: `${Math.max(11, Math.round(size * 0.28))}px`,
            color: theme === 'dark' ? '#D6CFC9' : '#736B65',
            fontWeight: 500,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            marginTop: '8px',
          }}>
            {subtitle}
          </span>
        )}
      </div>
    );
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: `${Math.round(size * 0.3)}px` }}>
      <img
        src="/emblem_square.png"
        alt="Luminous Break Emblem"
        width={size}
        height={size}
        style={{
          borderRadius: `${Math.round(size * 0.22)}px`,
          boxShadow: '0 3px 12px rgba(94, 75, 66, 0.08)',
          border: '1px solid rgba(230, 223, 213, 0.8)',
          display: 'block',
          objectFit: 'cover',
          backgroundColor: '#FFFFFF',
        }}
      />
      {showText && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{
            fontSize: `${Math.max(15, Math.round(size * 0.46))}px`,
            fontWeight: 700,
            color: theme === 'dark' ? '#FAF8F5' : '#3D3531',
            letterSpacing: '2.5px',
            textTransform: 'uppercase',
            display: 'block',
            lineHeight: 1.15,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
          }}>
            Luminous Break
          </span>
          {subtitle && (
            <span style={{
              display: 'block',
              fontSize: `${Math.max(10, Math.round(size * 0.26))}px`,
              color: theme === 'dark' ? '#C2B8B0' : '#786F69',
              fontWeight: 500,
              letterSpacing: '0.4px',
              marginTop: '3px',
            }}>
              {subtitle}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
